// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-selection[data-v-2d53bd87] {\n  height: 300px;\n}\n.no-selection p[data-v-2d53bd87] {\n  width: 400px;\n}", ""]);
// Exports
module.exports = exports;
